import script from "./ViewEditor.vue?vue&type=script&setup=true&lang=js"
export * from "./ViewEditor.vue?vue&type=script&setup=true&lang=js"

import "./ViewEditor.vue?vue&type=style&index=0&id=34e984ff&lang=css"

const __exports__ = script;

export default __exports__